import { useSelector } from 'react-redux'

import { useAssignmentsData } from './useAssignmentsData'
import { getSelectedAssignmentId } from '../../../../data/lyraTherapy/clientSelectors'

export const useSelectedAssignment = () => {
  const selectedAssignmentId = useSelector(getSelectedAssignmentId)
  const { data: assignments } = useAssignmentsData()
  if (!selectedAssignmentId) {
    return undefined
  }
  return assignments?.find((assignment) => assignment.id === selectedAssignmentId)
}
